import { Transition } from "@headlessui/react";
import { Slider } from "../utils/Slider";
// import pic1 from "./../assets/img/sliderTotalSolar-1.jpg";
// import pic2 from "./../assets/img/sliderTotalSolar-2.JPG";
// import pic3 from "./../assets/img/sliderTotalSolar-3.JPG";
import { Fragment, forwardRef, useRef } from "react";
import { useIsInViewport } from "../utils/CustomHooks";
import { ASSETS_URL } from "../utils/constants";

const pic1 = ASSETS_URL + 'tsiSliderTotalSolar-1.jpg'
const pic2 = ASSETS_URL + 'sliderTotalSolar-2.JPG'
const pic3 = ASSETS_URL + 'tsiSliderTotalSolar-3.png'
const pic4 = ASSETS_URL + 'tsiSliderTotalSolar-4.png'
//const pic4 = ASSETS_URL + 'SM City Butuan Solar Panel TotalSolarPH.png'


//text-[#9aed79] light green
export function HeroProjectsSlider() {

    //const [currentIndex, setCurrentIndex] = useState(0)

    
    const sliderConfig = {
        all: {
            enableAutoplay: true,
            autoplayInterval: 7000,
            transitionDuration: 200,
            slidesToShow: 1,
        },
      }
    
    return <>
        <div className="w-full font-[Montserrat]">
            <Slider config={sliderConfig} navBtnClass={'text-white'}>
                <SliderItem imageSrc={pic1} 
                            renderTextAnimation={(animate) => <>
                                <div className="w-[80%] h-full flex flex-col justify-center items-start">
                                    <SlideFrom open={animate} duration={'duration-[1000ms]'} from="translate-x-full"><SliderText textColor="text-white" fontSize="text-xl sm:text-2xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl 3xl:text-9xl">TOP-TIER <span className="text-[#4cb117]">SOLAR SOLUTIONS</span></SliderText></SlideFrom>
                                    <SlideFrom open={animate} duration={'duration-[2000ms]'} from="-translate-x-full"><SliderText textColor="text-white" fontSize="text-xl sm:text-2xl md:text-4xl lg:text-5xl xl:text-5xl 2xl:text-6xl 3xl:text-9xl">FOR YOUR HOME AND BUSINESS SITES</SliderText></SlideFrom>
                                </div>
                            </>} />
                <SliderItem imageSrc={pic2} 
                            renderTextAnimation={(animate)=><>
                                <div className="w-[80%] h-full flex flex-col justify-center items-start">
                                    <div className="w-[55%] sm:w-[60%] text-left relative p-4">
                                        <div className="hidden absolute top-0 left-0 w-full h-full bg-gray-500 opacity-50 rounded-xl"></div>
                                        <SlideFrom open={animate} duration={'duration-[1000ms]'} from="-translate-x-full">
                                            <SliderText textColor="text-white" fontSize="text-md sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-7xl">EMBRACE A SUSTAINABLE FUTURE,</SliderText>
                                        </SlideFrom>
                                        <SlideFrom open={animate} duration={'duration-[1000ms]'} from="-translate-x-full">
                                            <SliderText textColor="text-white" fontSize="text-md sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-7xl">SAVE ON ENERGY COST,</SliderText>
                                        </SlideFrom>
                                        <SlideFrom open={animate} duration={'duration-[2000ms]'} from="-translate-x-full">
                                            <SliderText textColor="text-[#4cb117]" fontSize="text-md sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-7xl">AND MAKE A POSITIVE IMPACT ON THE ENVIRONMENT </SliderText>
                                        </SlideFrom>
                                    </div>
                                </div>
                            </>} />
                <SliderItem imageSrc={pic3} 
                            renderTextAnimation={(animate)=><>
                                <div className="w-[80%] h-full flex flex-col justify-center items-end">
                                    <div className="w-[55%] sm:w-[60%] text-left relative p-4">
                                        <div className="hidden absolute top-0 left-0 w-full h-full bg-gray-500 opacity-50 rounded-xl"></div>
                                        <SlideFrom open={animate} duration={'duration-[1000ms]'} from="translate-x-full">
                                            <SliderText textColor="text-[#4cb117]" fontSize="text-md sm:text-lg md:text-xl lg:text-3xl xl:text-4xl 2xl:text-5xl 3xl:text-8xl">WE PROVIDE THE MOST EFFICIENT</SliderText>
                                        </SlideFrom>
                                        <SlideFrom open={animate} duration={'duration-[2000ms]'} from="translate-x-full">
                                            <SliderText textColor="text-white" fontSize="text-md sm:text-lg md:text-xl lg:text-3xl xl:text-4xl 2xl:text-5xl 3xl:text-8xl">AND COST-EFFECTIVE SOLAR SOLUTIONS AVAILABLE</SliderText>
                                        </SlideFrom>
                                    </div>
                                </div>
                            </>} />
                <SliderItem imageSrc={pic4} 
                    renderTextAnimation={(animate)=><>
                        <div className="w-[90%] h-full flex flex-col items-start mt-5">
                            <div className="w-[75%] sm:w-[60%] text-left relative p-4">
                                <div className="hidden absolute top-0 left-0 w-full h-full bg-gray-500 opacity-50 rounded-xl"></div>
                                <SlideFrom open={animate} duration={'duration-[1000ms]'} from="-translate-x-full">
                                    <SliderText textColor="text-[#4cb117]" fontSize="text-md sm:text-lg md:text-xl lg:text-5xl xl:text-5xl 2xl:text-6xl 3xl:text-7xl mb-3">SM SUPERMALLS</SliderText>
                                </SlideFrom>
                                <SlideFrom open={animate} duration={'duration-[2000ms]'} from="-translate-x-full">
                                    <SliderText textColor="text-white" fontSize="text-md sm:text-lg md:text-xl lg:text-xl xl:text-2xl 2xl:text-3xl 3xl:text-5xl">HAS TRANSITIONED TO USING SOLAR POWER ACROSS ITS MALLS IN THE PHILIPPINES, MARKING ITS MAJOR STEP TOWARD SUSTAINABILITY.</SliderText>
                                </SlideFrom>
                            </div>
                        </div>
                    </>}
                />
                    
            </Slider>
        </div>
    </>
}

const SliderImage =({imageSource}) => {
    return <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="w-full h-[50vh] sm:h-[80vh] min-h-[300px] object-cover" src={imageSource} />
}

const SliderItem = ({imageSrc, renderTextAnimation, children}) => {
    const itemRef = useRef(null)
    const isInViewport = useIsInViewport(itemRef);
    return <>
        <div ref={itemRef} className="w-full relative">
            <SliderImage imageSource={imageSrc} />
            
            <div className="top-0 absolute w-full h-full flex flex-col items-center">
                { renderTextAnimation(isInViewport) }
            </div>
        </div>
    </>
}
const SlideFrom = ({open, duration, from, children}) => {
    // const itemRef = useRef(null)
    // const isInViewport = useIsInViewport(itemRef);
    // const [show, setShow] = useState(open)
    // useEffect(() => {
    //     console.log('OPEN: ', open)
    //     setShow(open)
    // },[open])
    return <>
    <Transition
          as={Fragment}
          show={open}
          enter={`transform transition ${duration} ease-out`}
          enterFrom={`opacity-0 ${from}`}
          enterTo="opacity-100 translate-x-0"
          leave="transform duration-[200ms] transition ease-in"
          leaveFrom="opacity-100  translate-x-0"
          leaveTo="opacity-0 -translate-x-full"
        >
        {children}
    </Transition>
    </>
}



const SliderText = forwardRef(({textColor, fontSize, children}, forwardRef) => {
    //text-xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-8xl 
    return <>
        <div ref={forwardRef} 
            className={`drop-shadow-xl font-extrabold ${textColor} font-['Montserrat'] 
                        ${fontSize} 
                        `}
                        
                        style={{textShadow: '0px 1px gray'}}>{children}</div>
    </>
        
})